// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.driver-popover {
  max-width: 343px !important;
  font-size: 16px !important;
  border: 2px solid #cfe2fc;
  border-radius: 4px !important;
  padding: 16px;
  background-color: var(--sebrae-white) !important;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.driver-popover-title {
  border-bottom: 1px solid var(--sebrae-light-gray-2);
}

.driver-popover-next-btn,
.driver-popover-prev-btn {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  font-size: 13px !important;
  min-height: 32px !important;
  min-width: 71px !important;
  border-radius: 4px !important;
  border: 1px solid var(--sebrae-blue) !important;
  color: var(--sebrae-blue) !important;
}

.driver-popover-prev-btn {
  padding-right: 11px !important;
}

.driver-popover-description {
  margin-top: 20px !important;
}

.driver-popover-footer {
  margin-top: 20px !important;
}

.company-pill-area .blocks-area {
  gap: 16px;
  margin: 24px 0 48px;
  cursor: auto;
  display: flex;
  overflow-x: auto;
  -webkit-user-select: none;
          user-select: none;
}
.company-pill-area .blocks-area:active {
  cursor: grabbing;
}
.company-pill-area .blocks-area .block {
  position: relative;
  height: 90px;
  padding: 0 13px;
  min-width: 139px;
  max-width: 139px;
  border-radius: 8px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: left;
  background-color: #fff;
  border: 1.5px solid black;
  border-radius: 8px;
  align-items: center;
  background: #fff;
}
.company-pill-area .blocks-area .block.lucro::before {
  border-radius: 8px;
  content: "";
  background-image: linear-gradient(180deg, #40bbff 0%, #3b4aff 100%);
  top: -3.5px;
  left: -3.5px;
  bottom: -3.5px;
  right: -3.5px;
  position: absolute;
  z-index: -1;
}
.company-pill-area .blocks-area .block.lucratividade::before {
  border-radius: 8px;
  content: "";
  background-image: linear-gradient(60deg, #f4455a 0%, #ffabab 100%);
  top: -3.5px;
  left: -3.5px;
  bottom: -3.5px;
  right: -3.5px;
  position: absolute;
  z-index: -1;
}
.company-pill-area .blocks-area .block.rentabilidade::before {
  border-radius: 8px;
  content: "";
  background-image: linear-gradient(60deg, #ffb380 0%, #ffed69 100%);
  top: -3.5px;
  left: -3.5px;
  bottom: -3.5px;
  right: -3.5px;
  position: absolute;
  z-index: -1;
}
.company-pill-area .blocks-area .block.prazo::before {
  border-radius: 8px;
  content: "";
  background-image: linear-gradient(60deg, #9285f9 0%, #cd5be8 100%);
  top: -3.5px;
  left: -3.5px;
  bottom: -3.5px;
  right: -3.5px;
  position: absolute;
  z-index: -1;
}
.company-pill-area .blocks-area .block.necessidade::before {
  border-radius: 8px;
  content: "";
  background-image: linear-gradient(60deg, #3b4aff 0%, #40bbff 100%);
  top: -3.5px;
  left: -3.5px;
  bottom: -3.5px;
  right: -3.5px;
  position: absolute;
  z-index: -1;
}
.company-pill-area .blocks-area .block p {
  text-align: left;
}
@media (max-width: 992px) {
  .company-pill-area .blocks-area {
    height: 115px;
    padding-left: 2px;
    align-items: center;
  }
  .company-pill-area .blocks-area .block.lucro::before {
    top: -2.5px;
  }
  .company-pill-area .blocks-area .block.lucratividade::before {
    top: -2.5px;
  }
  .company-pill-area .blocks-area .block.rentabilidade::before {
    top: -2.5px;
  }
  .company-pill-area .blocks-area .block.prazo::before {
    top: -2.5px;
  }
  .company-pill-area .blocks-area .block.necessidade::before {
    top: -2.5px;
  }
}
@media (max-width: 350px) {
  .company-pill-area .blocks-area .block.lucro::before {
    top: -3.5px;
  }
  .company-pill-area .blocks-area .block.lucratividade::before {
    top: -3.5px;
  }
  .company-pill-area .blocks-area .block.rentabilidade::before {
    top: -3.5px;
  }
  .company-pill-area .blocks-area .block.prazo::before {
    top: -3.5px;
  }
  .company-pill-area .blocks-area .block.necessidade::before {
    top: -3.5px;
  }
}
@media (min-width: 993px) {
  .company-pill-area .blocks-area {
    gap: 24px;
    width: 90%;
    padding: 5px;
    flex-wrap: wrap;
  }
  .company-pill-area .blocks-area .block {
    min-width: 183px;
    max-width: 183px;
    height: 104px;
    padding: 0 16px;
    border: 1px solid transparent;
  }
  .company-pill-area .blocks-area .block p {
    font-size: 19px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/pill-planning/index.scss"],"names":[],"mappings":"AAcA;EACE,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,gDAAA;EACA,2CAAA;AAbF;;AAgBA;EACE,mDAAA;AAbF;;AAgBA;;EAEE,aAAA;EACA,8BAAA;EACA,kCAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,+CAAA;EACA,oCAAA;AAbF;;AAgBA;EACE,8BAAA;AAbF;;AAgBA;EACE,2BAAA;AAbF;;AAgBA;EACE,2BAAA;AAbF;;AAiBE;EACE,SAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAdJ;AAgBI;EACE,gBAAA;AAdN;AAiBI;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAfN;AAjEE;EACE,kBAAA;EACA,WAAA;EACA,mEAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAmEJ;AA5EE;EACE,kBAAA;EACA,WAAA;EACA,kEAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AA8EJ;AAvFE;EACE,kBAAA;EACA,WAAA;EACA,kEAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAyFJ;AAlGE;EACE,kBAAA;EACA,WAAA;EACA,kEAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAoGJ;AA7GE;EACE,kBAAA;EACA,WAAA;EACA,kEAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AA+GJ;AAlBM;EACE,gBAAA;AAoBR;AAfE;EACE;IACE,aAAA;IACA,iBAAA;IACA,mBAAA;EAiBJ;EAbQ;IACE,WAAA;EAeV;EAXQ;IACE,WAAA;EAaV;EATQ;IACE,WAAA;EAWV;EAPQ;IACE,WAAA;EASV;EALQ;IACE,WAAA;EAOV;AACF;AADE;EAIQ;IACE,WAAA;EAAV;EAIQ;IACE,WAAA;EAFV;EAMQ;IACE,WAAA;EAJV;EAQQ;IACE,WAAA;EANV;EAUQ;IACE,WAAA;EARV;AACF;AAcE;EACE;IACE,SAAA;IACA,UAAA;IACA,YAAA;IACA,eAAA;EAZJ;EAcI;IACE,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,eAAA;IACA,6BAAA;EAZN;EAcM;IACE,eAAA;EAZR;AACF","sourcesContent":["@mixin gradient-border($color1, $color2, $angle) {\n  &::before {\n    border-radius: 8px;\n    content: \"\";\n    background-image: linear-gradient($angle, $color1 0%, $color2 100%);\n    top: -3.5px;\n    left: -3.5px;\n    bottom: -3.5px;\n    right: -3.5px;\n    position: absolute;\n    z-index: -1;\n  }\n}\n\n.driver-popover {\n  max-width: 343px !important;\n  font-size: 16px !important;\n  border: 2px solid #cfe2fc;\n  border-radius: 4px !important;\n  padding: 16px;\n  background-color: var(--sebrae-white) !important;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.driver-popover-title {\n  border-bottom: 1px solid var(--sebrae-light-gray-2);\n}\n\n.driver-popover-next-btn,\n.driver-popover-prev-btn {\n  display: flex;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 13px !important;\n  min-height: 32px !important;\n  min-width: 71px !important;\n  border-radius: 4px !important;\n  border: 1px solid var(--sebrae-blue) !important;\n  color: var(--sebrae-blue) !important;\n}\n\n.driver-popover-prev-btn {\n  padding-right: 11px !important;\n}\n\n.driver-popover-description {\n  margin-top: 20px !important;\n}\n\n.driver-popover-footer {\n  margin-top: 20px !important;\n}\n\n.company-pill-area {\n  .blocks-area {\n    gap: 16px;\n    margin: 24px 0 48px;\n    cursor: auto;\n    display: flex;\n    overflow-x: auto;\n    user-select: none;\n\n    &:active {\n      cursor: grabbing;\n    }\n\n    .block {\n      position: relative;\n      height: 90px;\n      padding: 0 13px;\n      min-width: 139px;\n      max-width: 139px;\n      border-radius: 8px;\n      display: flex;\n      text-align: center;\n      align-items: center;\n      justify-content: left;\n      background-color: #fff;\n      border: 1.5px solid black;\n      border-radius: 8px;\n      align-items: center;\n      background: #fff;\n\n      &.lucro {\n        @include gradient-border(#40bbff, #3b4aff, 180deg);\n      }\n\n      &.lucratividade {\n        @include gradient-border(#f4455a, #ffabab, 60deg);\n      }\n\n      &.rentabilidade {\n        @include gradient-border(#ffb380, #ffed69, 60deg);\n      }\n\n      &.prazo {\n        @include gradient-border(#9285f9, #cd5be8, 60deg);\n      }\n\n      &.necessidade {\n        @include gradient-border(#3b4aff, #40bbff, 60deg);\n      }\n\n      p {\n        text-align: left;\n      }\n    }\n  }\n\n  @media (max-width: 992px) {\n    .blocks-area {\n      height: 115px;\n      padding-left: 2px;\n      align-items: center;\n\n      .block {\n        &.lucro {\n          &::before {\n            top: -2.5px;\n          }\n        }\n        &.lucratividade {\n          &::before {\n            top: -2.5px;\n          }\n        }\n        &.rentabilidade {\n          &::before {\n            top: -2.5px;\n          }\n        }\n        &.prazo {\n          &::before {\n            top: -2.5px;\n          }\n        }\n        &.necessidade {\n          &::before {\n            top: -2.5px;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 350px) {\n    .blocks-area {\n      .block {\n        &.lucro {\n          &::before {\n            top: -3.5px;\n          }\n        }\n        &.lucratividade {\n          &::before {\n            top: -3.5px;\n          }\n        }\n        &.rentabilidade {\n          &::before {\n            top: -3.5px;\n          }\n        }\n        &.prazo {\n          &::before {\n            top: -3.5px;\n          }\n        }\n        &.necessidade {\n          &::before {\n            top: -3.5px;\n          }\n        }\n      }\n    }\n  }\n\n  @media (min-width: 993px) {\n    .blocks-area {\n      gap: 24px;\n      width: 90%;\n      padding: 5px;\n      flex-wrap: wrap;\n\n      .block {\n        min-width: 183px;\n        max-width: 183px;\n        height: 104px;\n        padding: 0 16px;\n        border: 1px solid transparent;\n\n        p {\n          font-size: 19px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
